import { MessageCircle, CheckCircle2 } from "lucide-react";
import { Seo } from "../components/Seo";
import { Reveal } from "../components/Reveal";
import { waLink, IMAGES } from "../lib/site";

export default function ServicePage({ config }) {
  const { path, seoTitle, seoDesc, h1, intro, points, image, imageAlt } = config;
  return (
    <main className="bg-[#08090C] pt-24 sm:pt-32 pb-20 min-h-screen">
      <Seo title={seoTitle} description={seoDesc} path={path} />
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid lg:grid-cols-2 gap-12 items-center">
          <Reveal>
            <span className="inline-flex items-center gap-2 font-mono text-xs tracking-[0.25em] uppercase text-red-500 mb-5">
              <span className="h-px w-8 bg-current inline-block" />
              خدماتنا
            </span>
            <h1 className="font-display text-3xl sm:text-4xl lg:text-5xl font-extrabold text-white tracking-tight leading-[1.2] mb-6">
              {h1}
            </h1>
            <p className="text-slate-300 leading-relaxed text-base sm:text-lg mb-8">{intro}</p>
            <ul className="space-y-4 mb-10">
              {points.map((p) => (
                <li key={p} className="flex items-start gap-3 text-sm sm:text-base text-slate-300">
                  <CheckCircle2 size={19} className="text-red-500 mt-0.5 shrink-0" />
                  {p}
                </li>
              ))}
            </ul>
            <div className="flex flex-wrap gap-4">
              <a
                href={waLink(`السلام عليكم، أرغب في الاستفسار عن: ${h1}`)}
                target="_blank"
                rel="noopener noreferrer"
                data-testid="service-page-whatsapp-btn"
                className="inline-flex items-center gap-2.5 bg-emerald-600 hover:bg-emerald-500 text-white font-bold px-7 py-3.5 rounded-full shadow-[0_4px_24px_rgba(16,185,129,0.4)] transition-all active:scale-[0.97]"
              >
                <MessageCircle size={19} />
                استفسر عبر واتساب
              </a>
              <a
                href="/#finder"
                data-testid="service-page-finder-btn"
                className="inline-flex items-center gap-2.5 bg-white/5 hover:bg-white/10 text-white border border-white/15 font-semibold px-7 py-3.5 rounded-full transition-all"
              >
                اعرف الحساس المناسب
              </a>
            </div>
          </Reveal>
          <Reveal delay={0.15}>
            <div className="relative rounded-3xl overflow-hidden border border-white/10">
              <img
                src={image || IMAGES.heroRim}
                alt={imageAlt}
                className="w-full h-[320px] sm:h-[420px] object-cover"
                loading="lazy"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-[#08090C]/80 via-transparent to-transparent" />
            </div>
          </Reveal>
        </div>
      </div>
    </main>
  );
}
